import { useNavigate } from 'react-router-dom';

const features = [
  {
    icon: 'ri-search-eye-line',
    title: 'Product Discovery',
    description: 'Find organized products quickly through curated Basetao Spreadsheet collections and category links.',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Price Comparison',
    description: 'Compare products and costs easily using our comprehensive Basetao Spreadsheet resources.',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Shopping Education',
    description: 'Learn how Basetao works with detailed guides covering every aspect of the shopping experience.',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Smart Buying',
    description: 'Reduce mistakes before ordering with expert tips, reviews, and verified product information.',
    color: 'bg-primary-100 text-primary-700',
  },
];

export default function Features() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Why Thousands Of Users Search For Basetao Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Basetao Spreadsheet has become the go-to resource for organized shopping. Here is why savvy shoppers rely on these powerful tools to make informed purchasing decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div key={feature.title} className="bg-background-50 rounded-lg p-5 md:p-6 hover:bg-background-50 transition-colors duration-200">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-4 ${feature.color}`}>
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/basetao-spreadsheet-guide')}
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
          >
            Learn More About Basetao Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}